import C from 'cesium';

/**
 * Builds the tile server provider for the viewer.
 *
 * @returns {object} The cesium layer to add to the viewer.
 */
const addOnlineBaseMapCesium = () => {
  const imageryProvider = new C.UrlTemplateImageryProvider({
    url:
      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
    credit: 'Esri',
    subdomains: ''
  });
  return new C.ImageryLayer(imageryProvider, { alpha: 0.5 });
};

export default addOnlineBaseMapCesium;
